import {
  MainNewsWrapper, NewsDataWrapper,
  NewsItem,
  NewsItemDate,
  NewsItemTitle, NewsWrapper, SecondaryNewsWrapper
} from "pages/Main/main.styles";
import React, { useEffect, useState } from "react";
import { useIsMobile } from "hooks";
import { INews } from "models/others";
import { getNews } from "api/others";
import { SliderNews } from "components/atoms/SliderNews/SliderNews";

const MainNews = () => {
  const isMobile = useIsMobile();

  const [newsData, setNewsData] = useState<INews[]>([]);
  const items = newsData.slice(1, 5) || [];

  const loadNews = async () => {
    try {
      const response = await getNews();
      setNewsData(response)
    } catch (e) {
      //
    }
  }

  useEffect(() => {
    loadNews();
  }, []);

  if (!items || newsData.length < 5) return <></>;

  return (
    <NewsWrapper>
      <MainNewsWrapper>
        <NewsItem>
          <img src={newsData[0].image} alt={newsData[0].title}/>
          <NewsDataWrapper>
            <NewsItemTitle>{newsData[0].title}</NewsItemTitle>
            <NewsItemDate>{new Date(newsData[0].created_at).toLocaleDateString('ru')}</NewsItemDate>
          </NewsDataWrapper>
        </NewsItem>
      </MainNewsWrapper>

      {isMobile ? (
        <>
          {items.length && <SliderNews news={items}/>}
        </>
      ) : (
        <SecondaryNewsWrapper>
          {items.map((item) => (
            <NewsItem key={item.id}>
              <img src={item.image} alt={item.title}/>
              <NewsDataWrapper>
                <NewsItemTitle>{item.title}</NewsItemTitle>
                <NewsItemDate>{new Date(item.created_at).toLocaleDateString('ru')}</NewsItemDate>
              </NewsDataWrapper>
            </NewsItem>
          ))}
        </SecondaryNewsWrapper>
      )}
    </NewsWrapper>
  );
};

export default MainNews;
